import { InputfieldTypes } from "../../../../../enums/InputFieldAttributesEnums";
import { FetchInvoiceFiltersDataType } from "../../../../../Types/invoiceManagementTypes";
import {
  InvoiceFilterIds,
  InvoiceStatus,
  QuickbookStatus,
} from "../../../../../enums/InvoiceManagementEnums";

interface FilterFormFieldType {
  name: string;
  label: string;
  type: InputfieldTypes;
  bordered: boolean;
  placeholder?: string;
  width?: string;
  setSearch?: () => void;
  searchValue?: string;
}

interface FilterFormParamTye {
  customerSearchValue?: string;
  jobIdSearchValue?: string;
  orderSearchValue?: string;
  invoiceSearchValue?: string;
  statusSearchValue?: string;
  quickBookStatusSearchValue?: string;
  setCustomerSearchValue?: () => void;
  setJobIdSearchValue?: () => void;
  setOrderSearchValue?: () => void;
  setInvoiceSearchValue?: () => void;
  setStatusSearchValue?: () => void;
  setQuickBookStatusSearchValue?: () => void;
}

export const filterFieldConstants = {
  // Labels
  INVOICE_ID_FILTER_LABEL: "Invoice ID",
  CUSTOMER_FILTER_LABEL: "Customer",
  JOB_FILTER_LABEL: "Job",
  ORDER_FILTER_LABEL: "Order",
  DATE_FILTER_LABEL: "Date",
  STATUS_FILTER_LABEL: "Status",
  QUICKBOOK_STATUS_FILTER_LABEL: "Quickbook Status",

  // Names
  INVOICE_ID_FILTER_NAME: "invoiceId",
  CUSTOMER_ID_FILTER_NAME: "companyId",
  JOB_ID_FILTER_NAME: "jobId",
  ORDER_ID_FILTER_NAME: "orderId",
  FILTER_DATE_RANGE_FILTER_NAME: "dateRange",
  STATUS_FILTER_NAME: "invoiceStatus",
  QUICKBOOK_STATUS_FILTER_NAME: "syncStatus",

  //Placeholder
  PLACEHOLDER: "Select",
};

export const getFilterFormFields = (
  params: FilterFormParamTye
): FilterFormFieldType[] => [
  {
    name: filterFieldConstants.INVOICE_ID_FILTER_NAME,
    label: filterFieldConstants.INVOICE_ID_FILTER_LABEL,
    type: InputfieldTypes.MULTIPLE_SELECT_SEARCH,
    bordered: true,
    placeholder: filterFieldConstants.PLACEHOLDER,
    setSearch: params.setInvoiceSearchValue,
    searchValue: params.invoiceSearchValue,
  },
  {
    name: filterFieldConstants.CUSTOMER_ID_FILTER_NAME,
    label: filterFieldConstants.CUSTOMER_FILTER_LABEL,
    type: InputfieldTypes.MULTIPLE_SELECT_SEARCH,
    bordered: true,
    placeholder: filterFieldConstants.PLACEHOLDER,
    setSearch: params.setCustomerSearchValue,
    searchValue: params.customerSearchValue,
  },
  {
    name: filterFieldConstants.JOB_ID_FILTER_NAME,
    label: filterFieldConstants.JOB_FILTER_LABEL,
    type: InputfieldTypes.MULTIPLE_SELECT_SEARCH,
    bordered: true,
    placeholder: filterFieldConstants.PLACEHOLDER,
    setSearch: params.setJobIdSearchValue,
    searchValue: params.jobIdSearchValue,
  },
  {
    name: filterFieldConstants.ORDER_ID_FILTER_NAME,
    label: filterFieldConstants.ORDER_FILTER_LABEL,
    type: InputfieldTypes.MULTIPLE_SELECT_SEARCH,
    bordered: true,
    placeholder: filterFieldConstants.PLACEHOLDER,
    setSearch: params.setOrderSearchValue,
    searchValue: params.orderSearchValue,
  },
  {
    name: filterFieldConstants.FILTER_DATE_RANGE_FILTER_NAME,
    label: filterFieldConstants.DATE_FILTER_LABEL,
    type: InputfieldTypes.RANGE_PICKER,
  },
  {
    name: filterFieldConstants.STATUS_FILTER_NAME,
    label: filterFieldConstants.STATUS_FILTER_LABEL,
    type: InputfieldTypes.MULTIPLE_SELECT_SEARCH,
    bordered: true,
    placeholder: filterFieldConstants.PLACEHOLDER,
    setSearch: params.setStatusSearchValue,
    searchValue: params.statusSearchValue,
  },
  {
    name: filterFieldConstants.QUICKBOOK_STATUS_FILTER_NAME,
    label: filterFieldConstants.QUICKBOOK_STATUS_FILTER_LABEL,
    type: InputfieldTypes.MULTIPLE_SELECT_SEARCH,
    bordered: true,
    placeholder: filterFieldConstants.PLACEHOLDER,
    setSearch: params.setQuickBookStatusSearchValue,
    searchValue: params.quickBookStatusSearchValue,
  },
];

export const filterFieldToIdMap = {
  invoiceId: InvoiceFilterIds.INVOICES,
  companyId: InvoiceFilterIds.CUSTOMERS,
  jobId: InvoiceFilterIds.JOBS,
  orderId: InvoiceFilterIds.ORDERS,
  invoiceStatus: InvoiceFilterIds.INVOICE_STATUS,
  syncStatus: InvoiceFilterIds.SYNC_STATUS,
};

export const filterIdToFieldMap = {
  [InvoiceFilterIds.INVOICES]: "invoiceId",
  [InvoiceFilterIds.CUSTOMERS]: "companyId",
  [InvoiceFilterIds.JOBS]: "jobId",
  [InvoiceFilterIds.ORDERS]: "orderId",
  [InvoiceFilterIds.INVOICE_STATUS]: "invoiceStatus",
  [InvoiceFilterIds.SYNC_STATUS]: "syncStatus",
};

export const filterEmptyValues = (obj, currentFilter, clickableOrder) => {
  let objectToFilter = { ...obj };

  if (
    currentFilter &&
    Array.isArray(clickableOrder) &&
    clickableOrder.length > 0
  ) {
    const currentIndex = clickableOrder.indexOf(currentFilter);

    if (currentIndex > -1) {
      const subsequentFilterIds = clickableOrder.slice(currentIndex + 1);
      const keysToRemove = subsequentFilterIds.map(
        (id) => filterIdToFieldMap[id]
      );
      keysToRemove.forEach((key) => {
        if (key in objectToFilter) {
          delete objectToFilter[key];
        }
      });
    }
  }

  const recursiveClean = (currentObj) => {
    if (typeof currentObj !== "object" || currentObj === null) {
      return currentObj;
    }

    if (Array.isArray(currentObj)) {
      return currentObj
        .map(recursiveClean)
        .filter((item) => item !== undefined && item !== null);
    }

    const filteredObj = Object.entries(currentObj).reduce(
      (acc, [key, value]) => {
        const processedValue =
          typeof value === "object" ? recursiveClean(value) : value;

        // Keep values that are not null/undefined and not empty objects
        if (
          processedValue !== undefined &&
          processedValue !== null &&
          (typeof processedValue !== "object" ||
            Object.keys(processedValue).length > 0)
        ) {
          acc[key] = processedValue;
        }
        return acc;
      },
      {}
    );

    return Object.keys(filteredObj).length > 0 ? filteredObj : undefined;
  };

  return recursiveClean(objectToFilter);
};

export const getPreviousFilter = (filterField, updatedClickOrder) => {
  const currentIndex = updatedClickOrder?.indexOf(filterField);
  if (currentIndex <= 0) {
    return undefined;
  }
  return updatedClickOrder[currentIndex - 1];
};
